import React, { useContext, useState } from 'react';
import { AppContext } from '../../store/contexts/AppContext.js';
import { login } from '../../helpers/SSO.js';
import { Modal } from '_ui-core-js/React/components/Modal.jsx';
import { AlertTextContent } from '_ui-core-js/React/components/AlertTextContent.jsx';
import { constants } from '../../constants';
import { useEscapeKey } from '_ui-core-js/React/hooks/useEscapeKey.js';

export default function GuestUserPrompt() {

	const context = useContext(AppContext);
	const { cmsConfiguration,  setCustomerProfile, setUserToken, setIsUserLoggedIn, setGuestExpiryTime  } = context;
	const [ closePrompt, setClosePrompt ] = useState(false);
    const { LOCAL_STORAGE_KEYS} = constants
    
    const labels = _.get(cmsConfiguration, 'labels.guestPrompt', {});
    const {
        heading,
        subheading,
        copy,
        buttonLabel,
        secondaryButtonLabel
    } = labels;
	
    const handleLoginAction = () => {
		login(setCustomerProfile, setUserToken, setIsUserLoggedIn);
	}; 

    function handleCancelAction () {
        const currentTime = Date.now();
        const thirtyMinutesfromNow = currentTime + 30 * 60 * 1000;
        
        setClosePrompt(true);
        setGuestExpiryTime(thirtyMinutesfromNow);
        localStorage.setItem(LOCAL_STORAGE_KEYS.GUEST, JSON.stringify(thirtyMinutesfromNow))
    }

    useEscapeKey(handleCancelAction);

	return ( 
	  <Modal
      id='lbx-experience-guest-user'
      showCloseButton={false}
      showModalTrigger={true}
      backgroundModifier={'transparent'}
      closeModalTrigger={closePrompt}
      centered={true}
      >
        <AlertTextContent
        heading={heading}
        subheading={subheading}
        body={copy}
        buttonLabel={buttonLabel}
        onClickCallback={() => {handleLoginAction()}}
        secondaryButtonLabel={secondaryButtonLabel}
        secondaryOnClickCallback={handleCancelAction}
        />
      </Modal>    
	)  
}